var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9C9CAE",
    fillRule: "evenodd",
    d: "M16 0a16 16 0 1 1 0 32 16 16 0 0 1 0-32zm7.34 23.08A1 1 0 0 0 23 21.7c-4.22-2.57-9.45-3.17-15.54-1.78a1 1 0 1 0 .44 1.94c5.57-1.27 10.3-.75 14.06 1.55a1 1 0 0 0 1.37-.33zm1.96-4.36c.36-.59.17-1.35-.42-1.72-4.93-3.03-12.16-3.88-17.97-2.12a1.25 1.25 0 0 0 .73 2.39c5.08-1.55 11.64-.78 15.94 1.86.59.36 1.35.18 1.72-.41zm.16-4.54A1.5 1.5 0 1 0 27 11.61C21.05 8.08 11.66 7.75 6.01 9.47a1.5 1.5 0 0 0 .87 2.86c4.92-1.5 13.43-1.21 18.58 1.85z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpotify);
export default __webpack_public_path__ + "static/media/icon-spotify.789b7034122cfcd3e00b52699bf3bca5.svg";
export { ForwardRef as ReactComponent };